import { render, staticRenderFns } from "./starter.vue?vue&type=template&id=492e80a0&"
import script from "./starter.vue?vue&type=script&lang=js&"
export * from "./starter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports